<template>
  <div>
    <div>
      <a
        @click="clickedCategory(item, messageType)"
        v-for="(item, idx) in counselorButtons"
        :key="idx"
        :class="[item.channelName === 'NAVER_TALK' ? 'list naverTalk' : 'list']"
        v-show="item.type === 'COUNSELOR_BUTTON'"
      >
        <div class="UXBubbleCounselorItem">
          {{ item.text }}
          <span>
            <img
              :src="getCounselorIcon(item.channelName)"
              alt="상담하기 아이콘"
              width="16"
              :class="{ borderRadius: item.channelName !== 'FACEBOOK_TALK' }"
            />
          </span>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BubbleCounselorButtons',
  props: ['counselorButtons', 'messageType', 'clickedCategory'],
  methods: {
    getCounselorIcon(channelName) {
      let srcUrl = '';
      switch (channelName) {
        case 'KAKAO_TALK':
          srcUrl = 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/icon_kakao.png';
          break;
        case 'NAVER_TALK':
          srcUrl = 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/icon_naver.png';
          break;
        case 'WEB_CHAT':
          srcUrl = 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/icon_webchat_v2.png';
          break;
        case 'FACEBOOK_TALK':
          srcUrl = 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/icon_facebook_messenger.png';
          break;
        default:
          srcUrl = 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/icon_webchat_v2.png';
          break;
      }
      return srcUrl;
    }
  }
};
</script>

<style lang="scss" scoped>
.btnBubble {
  padding: 20px 0 10px 0px;
}
.UXBubbleCounselorItem {
  position: relative;
  margin: 0 10px 10px 0;
  padding: 2px 40px 2px 20px;
  word-break: break-all;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-height: 35px;
  color: #2645b6;
  font-size: 14px;
  border-radius: 20px;
  border: 1px solid #cbcbcb;
  background: #fff;
  & img {
    position: absolute;
    top: 48%;
    right: 20px;
    margin-top: -8px;
    cursor: pointer;
    &.borderRadius {
      border-radius: 30px;
    }
  }
  &:hover {
    color: var(--gray-gray-0, #fff);
    border: 1px solid #3c5fc8;
    background: #5578f0 !important;
    box-shadow: 0px 2px 5px 0px rgba(115, 115, 115, 0.3);
  }
}
</style>
